import React from "react";
import styled from "styled-components";

export const Logo = () => {
  return <StyledLogo>SK</StyledLogo>;
};

const StyledLogo = styled.div`
  font-size: 1.6rem;
  font-family: "Comfortaa", cursive;
  font-weight: 700;
`;
